import { jsx as a } from "@emotion/react/jsx-runtime";
import t, { tabClasses as b } from "@mui/material/Tab";
import e, { tabsClasses as o } from "@mui/material/Tabs";
const n = b, r = ({ ...s }) => /* @__PURE__ */ a(t, { ...s });
r.displayName = "Tab";
const p = o, l = ({ ...s }) => /* @__PURE__ */ a(e, { ...s });
l.displayName = "Tabs";
export {
  r as T,
  p as a,
  l as b,
  n as t
};
